<template>
  <div class="deposit-container">
    <div class="deposit">
      <div class="deposit__content">
        <div class="deposit__header">
          <p class="deposit__title">支付方式</p>
          <a
            v-if="selectedPaymentMethod && selectedPaymentMethod.download_name && selectedPaymentMethod.download_url"
            :href="selectedPaymentMethod.download_url"
            target="_blank"
            class="download-btn"
          >{{ selectedPaymentMethod.download_name }}</a>
        </div>

        <div class="deposit__list-container">
          <ul class="deposit__list">
            <li
              v-for="method in filteredPaymentMethods"
              :key="method.id"
              class="deposit__item"
              :class="{ active: selectedPaymentMethod && selectedPaymentMethod.id === method.id }"
              @click="selectPaymentMethod(method)"
            >
              <img :src="method.img" :alt="method.name" class="deposit__icon" />
              <p>{{ method.name }}</p>
            </li>
          </ul>
        </div>

        <div v-if="isUsdtMethod" class="protocol-box">
          <p class="sub-tips">钱包协议</p>
          <div class="dcbox-protocol">
            <div
              :class="meyXi === 'TRC20' ? 'protocol-item active' : 'protocol-item'"
              @click="changMeyXi('TRC20')"
            >
              <span class="circle"></span>
              <span class="text">TRC20</span>
              <img src="/static/image/tuijian.svg" alt="推荐" class="protocol-recommend" />
            </div>
            <div
              :class="meyXi === 'ERC20' ? 'protocol-item active' : 'protocol-item'"
              @click="changMeyXi('ERC20')"
            >
              <span class="circle"></span>
              <span class="text">ERC20</span>
            </div>
          </div>
        </div>

        <div class="deposit-input">
          <p class="deposit-input-title">存款金额</p>
          <div class="deposit__amount-input-wrapper">
            <input
              v-model="depositAmount"
              type="number"
              class="deposit__amount-input"
              placeholder="请输入存款金额"
              :min="selectedPaymentMethod ? selectedPaymentMethod.min_price : 0"
              :max="selectedPaymentMethod ? selectedPaymentMethod.max_price : 999999"
            />
            <span class="deposit__amount-unit">¥</span>
          </div>
          <p v-if="selectedPaymentMethod && selectedPaymentMethod.remark" class="payment-remark">
            {{ selectedPaymentMethod.remark }}
          </p>
        </div>

        <div class="quick-amount-grid">
          <span v-for="item in quickAmounts" :key="item" class="quick-btn" @click="selectAmount(item)">
            {{ formatQuickAmount(item) }}
          </span>
        </div>

        <div class="wxsm-tips">
          <i class="tips-icon"></i>
          <div class="tips-text">
            温馨提示：请在规定时间内完成存款，超时则无法到账，如有疑问请
            <span class="kefu-link" @click="openKefu">联系客服</span>
          </div>
        </div>
        <p style="color: red; font-size: 14px; margin: 8px 0;">
          当前限额：{{ min_price }} - {{ max_price }} 元
        </p>
        <button class="deposit__button" :class="{ disabled: !canSubmit }" @click="confirmDeposit">
          确认存款
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      bankBox: {},
      meyXi: 'TRC20',
      min_price: 100,
      max_price: 100000,
      currentTab: '热门',
      categoryMap: {
        热门: 'hot',
      },
      allPaymentMethods: [],
      selectedPaymentMethod: null,
      selectedMethod: null,
      depositAmount: '',
      amount: null,
      quickAmounts: [100, 200, 500, 1000, 2000, 5000, 10000, 30000, 50000],
    };
  },
  computed: {
    filteredPaymentMethods() {
      return this.allPaymentMethods;
    },
    isUsdtMethod() {
      return this.selectedPaymentMethod && (
        this.selectedPaymentMethod.type === 'usdt_pay' || this.pay_way === 'usdt'
      );
    },
    canSubmit() {
      const amount = Number(this.depositAmount || this.amount);
      return this.selectedPaymentMethod && amount && amount >= this.min_price && amount <= this.max_price;
    },
  },
  created() {
    this.getPaymentMethodsFromBackend();
  },
  methods: {
    getPaymentIcon(item) {
      if (item.type === 'usdt_pay') {
        return '/static/image/usdt.png';
      }
      if (item.img) {
        return item.img;
      }
      const dataType = item.data && (item.data.type || item.data.key);
      return this.getDefaultIcon(dataType || item.type);
    },
    getDefaultIcon(type) {
      const iconMap = {
        bank: '/static/style/unionpay.cdca8e6e.png',
        card: '/static/style/unionpay.cdca8e6e.png',
        usdt: '/static/image/usdt.png',
        usdt_pay: '/static/image/usdt.png',
        epayusdt: '/static/style/usdt.svg',
        wechat: '/static/style/wechat.svg',
        wxpay: '/static/style/wechat.svg',
        alipay: '/static/style/alipay.svg',
        code_pay: '/static/style/alipay.svg',
      };
      return iconMap[type] || '/static/style/alipay.svg';
    },
    getPaymentMethodsFromBackend() {
      const that = this;
      that.showLoading();
      const category = that.categoryMap[that.currentTab];

      that.$apiFun
        .get('/api/getAllPaymentMethods', { category })
        .then(res => {
          if (res.code == 200 && res.data) {
            that.allPaymentMethods = res.data.map(item => ({
              id: item.id,
              type: item.type,
              name: item.name || '支付方式',
              category: that.currentTab,
              img: that.getPaymentIcon(item),
              min_price: item.min_price,
              max_price: item.max_price,
              data: item.data,
              remark: item.data ? item.data.remark : '',
              download_name: item.data ? item.data.download_name : '',
              download_url: item.data ? item.data.download_url : '',
            }));

            if (that.allPaymentMethods.length > 0) {
              that.selectPaymentMethod(that.allPaymentMethods[0]);
            }
          }
          that.hideLoading();
        })
        .catch(() => {
          that.hideLoading();
        });
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
      this.selectedMethod = method;
      if (method.min_price) {
        this.min_price = method.min_price;
      }
      if (method.max_price) {
        this.max_price = method.max_price;
      }

      if (method.type === 'usdt_pay') {
        this.pay_way = 'usdt';
      } else if (method.type === 'code_pay') {
        const content = (method.data && method.data.content) || method.name || '';
        if (/usdt/i.test(content) || (method.data && method.data.key === 'usdt')) {
          this.pay_way = 'usdt';
        } else if (method.data && method.data.key === 'alipay') {
          this.pay_way = 'alipay';
        } else if (method.data && (method.data.key === 'wechat' || method.data.key === 'wxpay')) {
          this.pay_way = 'wechat';
        } else if (method.data && method.data.key === 'bank') {
          this.pay_way = 'bank';
        } else {
          this.pay_way = 'alipay';
        }
      } else {
        this.pay_way = 'alipay';
      }
    },
    changMeyXi(val) {
      this.meyXi = val;
    },
    payTest() {
      const that = this;
      const amount = Number(that.depositAmount || that.amount);

      if (!that.selectedMethod) {
        that.showTost(0, '请选择支付方式');
        return;
      }

      if (amount < that.min_price || amount > that.max_price) {
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }

      let info = {
        paytype: that.pay_way,
        amount,
      };

      if (that.selectedPaymentMethod.type === 'code_pay') {
        info.method_id = that.selectedMethod.id;
      }

      if (that.pay_way === 'usdt') {
        info.catepay = that.meyXi;
      }

      that.showLoading();
      info.paytype = info.paytype === 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            that.depositAmount = '';
            if (that.pay_way === 'bank') {
              that.showTost(1, '提交成功，等待后台审核');
              that.$router.push({ path: '/transRecord' });
              return;
            }
            that.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
          }
          that.hideLoading();
        })
        .catch(() => {
          that.hideLoading();
        });
    },
    confirmDeposit() {
      if (!this.canSubmit) {
        return;
      }
      this.payTest();
    },
    selectAmount(val) {
      this.amount = val;
      this.depositAmount = val;
    },
    formatQuickAmount(val) {
      if (val >= 10000) {
        return `${val / 10000}万`;
      }
      return val;
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
};
</script>

<style lang="scss" scoped>
.deposit-container {
  background: #fff;
  min-height: 100vh;
  padding: 60px 15px 15px;
  box-sizing: border-box;
  color: #333;
}

.deposit {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
}

.deposit__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.deposit__title {
  font-size: 16px;
  color: #333;
  margin: 0;
  font-weight: 500;
}

.download-btn {
  color: #cca352;
  font-size: 12px;
  text-decoration: none;
}

.deposit__list-container {
  margin-bottom: 16px;
}

.deposit__list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.deposit__item {
  flex: 1;
  min-width: calc(50% - 5px);
  text-align: center;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #eee;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 12px 10px;

  &.active {
    background: #fff8e6;
    border-color: #cca352;
    color: #333;
    box-shadow: 0 2px 8px rgba(204, 163, 82, 0.1);
  }

  p {
    margin: 8px 0 0;
    font-size: 14px;
  }
}

.deposit__icon {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  display: block;
  object-fit: contain;
}

.protocol-box {
  margin-bottom: 16px;
}

.sub-tips {
  font-size: 14px;
  color: #333;
  margin: 0 0 12px;
}

.dcbox-protocol {
  display: flex;
  gap: 20px;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 8px;
}

.protocol-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 6px 0;
  &.active {
    color: #cca352;
  }
}

.protocol-recommend {
  width: 55px;
  height: 42px;
  margin-left: 4px;
}

.circle {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}

.protocol-item.active .circle {
  border-color: #cca352;
}

.protocol-item.active .circle:after {
  content: '';
  width: 8px;
  height: 8px;
  background: #cca352;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.deposit-input-title {
  font-size: 16px;
  color: #333;
  margin: 0 0 12px;
  font-weight: 500;
}

.deposit__amount-input-wrapper {
  position: relative;
  background: #f8f9fa;
  border-radius: 8px;
  height: 50px;
  margin-bottom: 6px;
}

.deposit__amount-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 60px 0 18px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
  appearance: none;

  &::placeholder {
    color: #999;
    font-size: 14px;
  }
}

.deposit__amount-unit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 18px;
  background: #eee;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}

.payment-remark {
  margin: 0 0 10px;
  font-size: 13px;
  color: #999;
}

.quick-amount-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.quick-btn {
  background: #f8f9fa;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px 0;
  font-size: 13px;
  color: #333;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #fff8e6;
    border-color: #cca352;
    color: #cca352;
  }
}

.wxsm-tips {
  font-size: 13px;
  color: #666;
  background: #fff8e6;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.tips-icon {
  width: 18px;
  height: 18px;
  background: url(/static/image/tips-icon.png) no-repeat center;
  background-size: 18px 18px;
  margin-top: 1px;
  flex-shrink: 0;
}

.tips-text {
  line-height: 1.5;
}

.kefu-link {
  color: #cca352;
  cursor: pointer;
  text-decoration: underline;
}

.deposit__button {
  width: 100%;
  height: 50px;
  background: #cca352;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  transition: background 0.3s ease;
  margin-top: 4px;

  &.disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(.disabled) {
    background: #b89248;
  }
}

@media (max-width: 768px) {
  .deposit-container {
    padding-top: 55px;
  }
  .deposit {
    padding: 14px;
  }
  .deposit__item {
    min-width: calc(50% - 5px);
  }
  .quick-amount-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/recharge.vue